$(document).ready(function() {
    $('.news-detail-products .product-cards').slick({
        slidesToScroll: 1,
        slidesToShow: 3,
        dots: false,
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                  slidesToShow: 2
              }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    $('.last-news-wraper .news-items').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });
    $('.popular-categories .plates-list').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        responsive: [
            {
                breakpoint: 1651,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 501,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.slider-main')
        .on('init', function(slick) {
            $('.slider-main').closest('.main-slider').removeClass('is-hidden');
            $('.slider-main').fadeIn(3000);
        })
        .slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        dots: true,
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        infinite: true,
        speed: 1000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    });
    $('.brands-list').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        adaptiveWidth: true,
        infinite: true,
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        responsive: [
            {
                breakpoint: 1651,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1
                }
            }
        ]
    });
    function init_tabs_slider(containerSelector){
        var containerEl = document.querySelector(containerSelector);
        if( typeof containerEl !== "undefined" &&  containerEl != null ) {
            var mixer = mixitup(containerEl, {
                callbacks: {
                    onMixClick: function (state, originalEvent) {
                        $(containerSelector).slick('slickUnfilter');
                        console.log(1);
                    },
                    onMixEnd: function (state) {
                        $(containerSelector).find('.slick-slide').removeClass('activeToFilter');
                        $(state.show).closest('.slick-slide').addClass('activeToFilter');
                        $(containerSelector).slick('slickFilter', '.activeToFilter');
                        $('.cards-slider').slick('slickGoTo', 0);
                    }
                }
            });
        }
    }
    init_tabs_slider('.products-and-brands_viewed .product-cards');
    init_tabs_slider('.products-and-brands_main .product-cards');
    $('.cards-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        rows: 0,
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(window).on('load resize', function() {
        if ($(window).width() < 992) {
            $('.cards-advances').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<a href="#" class="prev-arrow"></a>',
                nextArrow: '<a href="#" class="next-arrow"></a>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            $('.news-items').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<a href="#" class="prev-arrow"></a>',
                nextArrow: '<a href="#" class="next-arrow"></a>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    });
    $(document).on('click', '.main-hamburger-mobile', function (e) {
        e.preventDefault();
        $(this).closest('.mobile-header').find('.mobile-header-menu').slideDown();
        $('body').toggleClass('stop-scroll');
        $('.background-overlay').slideToggle();
    });
    $(document).on('click', '.mobile-header-top__options-search', function (e) {
        e.preventDefault();
        $(this).closest('.mobile-header').find('.mobile-header__search').slideToggle();
        $('body').toggleClass('stop-scroll');
        $('.background-overlay').slideToggle();
    });
    $(document).on('click', '.menu-close', function (e) {
        e.preventDefault();
        $(this).closest('.mobile-header-menu').slideUp();
        $('body').toggleClass('stop-scroll');
        $('.background-overlay').slideUp();
    });
    $(document).on('click', '.menu-close', function (e) {
        e.preventDefault();
        $(this).closest('.mobile-header__search').slideUp();
        $('body').toggleClass('stop-scroll');
        $('.background-overlay').slideUp();
    });
    $(document).on('click', '.menu-close', function (e) {
        e.preventDefault();
        $(this).closest('.mobile-header__filter').slideUp();
        $('body').removeClass('stop-scroll');
        $('.background-overlay').slideUp();
    });


    $(document).on('click', '.header-bottom__catalogue-icon', function () {
        $('#header_menu_toggle').slideToggle();
        $(this).parent().toggleClass('btn-active');
        $(this).toggleClass('close-state');
    });
    $( function() {
        $( ".sort-block__select" ).selectmenu();
    } );
    $(function() {
        $('.filter-item__more').click(function(e){
            e.preventDefault();
            $(this).animate(
                {

                }, 500, function () {
                    $(this).prev('.filter-item__brands').children('.filter-brand-item').addClass('visible');
                    $(this).remove();
                });
        });
    });
    $(document).on('click', '.cards-count', function (e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings('.cards-count').removeClass('active');
    });
    $(document).on('click', '.cards-ui', function (e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings('.cards-ui').removeClass('active');
    });
    $(document).on('click', '.pagination-block__list-item', function () {
        $(this).addClass('selected');
        $(this).siblings().removeClass('selected');
    });
    $(document).on('click', '.filter-reset-link', function (e) {
        e.preventDefault();
        $(this).closest('.catalogue-filter').find('.filter-brand-item__hidden').prop('checked', false);
        $('.filter-item__range').each(function () {
            var obj = $(this);
            var rangeMin = obj.find('.range-min');
            var min = rangeMin.attr('placeholder');
            rangeMin.val(min);
            var rangeMax = obj.find('.range-max');
            var max = rangeMax.attr('placeholder');
            rangeMax.val(max);
            obj.find('.filter-range__scroll').slider('values',[min,max]);
        });
    });
    $(document).on('click', '.sort-block__filter', function (e) {
        e.preventDefault();
        $('.mobile-header__filter').slideToggle();
        $('body').addClass('stop-scroll');
        $('.background-overlay').slideToggle();
    });
    $(document).on('click', '.filter-item__name', function () {
        $(this).find('.filter-arrow').toggleClass('revert-arrow');
        $(this).closest('.filter-item').find('.filter-item__brands').slideToggle();
        $(this).closest('.filter-item').find('.filter-item__more').slideToggle();
    });
    $( function() {
        $( ".slider-range" ).slider({
            range: true,
            min: 9050,
            max: 128930,
            values: [ 9050, 128930 ],
            slide: function( event, ui ) {
                $( ".range-start" ).val( ui.values[ 0 ]);
                $( ".range-end" ).val(ui.values[ 1 ] );
            }
        });
        $( ".range-start" ).val( $( ".slider-range" ).slider( "values", 0 ) );
        $( ".range-end" ).val($( ".slider-range" ).slider( "values", 1 ) );
    } );
    $(document).on('click', '.sort-categories-click', function () {
        $(this).next('.catalogue-deep').slideToggle();
        $(this).prev('a').toggleClass('opened');
        $(this).toggleClass('rotate');
    });

    /*var default_input = $('.add-to-cart__input').val();
        if ($('.add-to-cart__input').closest('.add-to-cart').hasClass('cart-item-counter') == true) {
            $('.add-to-cart__input').val(parseInt(default_input));
            if (parseInt(default_input) <= 1) {
                $('.add-to-cart__minus').addClass('disabled');
            }
        } else {
            $('.add-to-cart__input').val(parseInt(default_input) + ' шт');
        }
        if (parseInt(default_input) == 0) {
            $('.add-to-cart__minus').addClass('disabled');
        } else {
            $('.add-to-cart__minus').removeClass('disabled');
        }*/
    $(document).on('click', '.add-to-cart__plus', function () {
        var this_input = $(this).closest('.add-to-cart').find('.add-to-cart__input');
        if (this_input.data('max-quantity') == '' || (parseInt(this_input.val())+1) <= this_input.data('max-quantity')) {
            if ($(this).closest('.add-to-cart').hasClass('cart-item-counter') == true) {
                this_input.val(parseInt(this_input.val()) + 1);
                if (parseInt(this_input.val()) < 2) {
                    this_input.prev('.add-to-cart__minus').addClass('disabled');
                } else {
                    this_input.prev('.add-to-cart__minus').removeClass('disabled');
                }
            } else {
                this_input.val(parseInt(this_input.val()) + 1 + ' шт');
            }

            this_input.prev('.add-to-cart__minus').removeClass('disabled');
        }
    });
    $(document).on('click', '.add-to-cart__minus', function () {
        var this_input = $(this).closest('.add-to-cart').find('.add-to-cart__input');
        var this_input_val = parseInt(this_input.val());
        if (this_input_val > 0) {
            if ($(this).closest('.add-to-cart').hasClass('cart-item-counter') == true) {
                this_input.val(this_input_val - 1);
            } else {
                this_input.val(this_input_val - 1 + ' шт');
            }

        }
        if (parseInt(this_input_val) <= 1)  {
            //this_input.prev('.add-to-cart__minus').addClass('disabled');
        }
    });
    $(document).on('click', '.card-btn-default', function () {
        var this_input = $(this).next('.add-to-cart').find('.add-to-cart__input');
        var this_input_val = parseInt(this_input.val());
        $(this).next('.add-to-cart').animate({
        }, 800, function() {
            $(this).addClass('add-cart-input');
        });
        if (this_input_val == 0) {
            this_input.val(this_input_val + 1 + ' шт');
        }else{
            this_input.val(this_input_val + ' шт');
        }
    });
    $(document).on('click', '.add-to-cart__minus', function () {
        if (parseInt($(this).next('.add-to-cart__input').val()) < 1) {
            $(this).parent('.add-to-cart').removeClass('add-cart-input');
        }
        if ($(this).closest('.add-to-cart').hasClass('cart-item-counter') == true) {
            if (parseInt($(this).next('.add-to-cart__input').val()) <= 1) {
                $(this).addClass('disabled');
            }
        }
    });
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    prevArrow: '<a href="#" class="prev-arrow"></a>',
                    nextArrow: '<a href="#" class="next-arrow"></a>'
                }
            }
        ]
    });
    if ($('.product-detail').hasClass('solutions-detail') == true) {
        var slidesShow = 6;
    } else {
        var slidesShow = 4;
    }
    $('.slider-nav').slick({
        slidesToShow: slidesShow,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        centerMode: true,
        focusOnSelect: true
    });
});

function loadXMLPreviewGrid()
{
    var xmlhttp;
    if (window.XMLHttpRequest)
    {// код для IE7+, Firefox, Chrome, Opera, Safari
        xmlhttp=new XMLHttpRequest();
    }
    else
    {// код для IE6, IE5
        xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange=function()
    {
        if (xmlhttp.readyState==4 && xmlhttp.status==200)
        {
            document.getElementById("catalogue_cards").innerHTML=xmlhttp.responseText;
        }
    }
    xmlhttp.open("GET","grid-cards-preview.html",true);
    xmlhttp.send();
}
function loadXMLSolutionsGrid()
{
    var xmlhttp;
    if (window.XMLHttpRequest)
    {// код для IE7+, Firefox, Chrome, Opera, Safari
        xmlhttp=new XMLHttpRequest();
    }
    else
    {// код для IE6, IE5
        xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange=function()
    {
        if (xmlhttp.readyState==4 && xmlhttp.status==200)
        {
            document.getElementById("catalogue_cards").innerHTML=xmlhttp.responseText;
        }
    }
    xmlhttp.open("GET","solutions_cards_grid1.html",true);
    xmlhttp.send();
}
function loadXMLPreviewList()
{
    var xmlhttp;
    if (window.XMLHttpRequest)
    {// код для IE7+, Firefox, Chrome, Opera, Safari
        xmlhttp=new XMLHttpRequest();
    }
    else
    {// код для IE6, IE5
        xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange=function()
    {
        if (xmlhttp.readyState==4 && xmlhttp.status==200)
        {
            document.getElementById("catalogue_cards").innerHTML=xmlhttp.responseText;
        }
    }
    xmlhttp.open("GET","list-cards-preview.html",true);
    xmlhttp.send();
}
function loadXMLSolutionsList()
{
    var xmlhttp;
    if (window.XMLHttpRequest)
    {// код для IE7+, Firefox, Chrome, Opera, Safari
        xmlhttp=new XMLHttpRequest();
    }
    else
    {// код для IE6, IE5
        xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange=function()
    {
        if (xmlhttp.readyState==4 && xmlhttp.status==200)
        {
            document.getElementById("catalogue_cards").innerHTML=xmlhttp.responseText;
        }
    }
    xmlhttp.open("GET","solutions_cards_list.html",true);
    xmlhttp.send();
}
$(document).ready(function() {
    //Horizontal Tab
    $('.characteristics-block__tab').easyResponsiveTabs({
        type: 'default', //Types: default, vertical, accordion
        width: 'auto', //auto or any width like 600px
        fit: true, // 100% fit in a container
        tabidentify: 'hor_1', // The tab groups identifier
        activate: function(event) { // Callback function if tab is switched
            var $tab = $(this);
            var $info = $('#nested-tabInfo');
            var $name = $('span', $info);
            $name.text($tab.text());
            $info.show();
        }
    });

// Child Tab
    $('#ChildVerticalTab_1').easyResponsiveTabs({
        type: 'vertical',
        width: 'auto',
        fit: true,
        tabidentify: 'ver_1', // The tab groups identifier
        activetab_bg: '', // background color for active tabs in this group
        inactive_bg: '', // background color for inactive tabs in this group
        active_border_color: '', // border color for active tabs heads in this group
        active_content_border_color: '' // border color for active tabs contect in this group so that it matches the tab head border
    });
    function scrollEase(selector) {
        $(selector).on('click', function() {
            let href = $(this).attr('href');
            if (href !== '#') {
                $('html, body').animate({
                    scrollTop: $(href).offset().top
                });
            }
            return false;
        });
    }
    scrollEase('.product-detail-bottom__info-characteristics');
});
$(document).ready(function () {
    $('.comparison-slider').slick({
        slidesToScroll: 1,
        slidesToShow: 4,
        focusOnSelect: true,
        infinite: false,
        arrows: true,
        prevArrow: '<a href="#" class="prev-arrow"></a>',
        nextArrow: '<a href="#" class="next-arrow"></a>',
        swipe: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    $('.comparison-table').on('init', function(event, slick) {
        $('.comparison-table .slick-slide.slick-current').addClass('is-active');
    }).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: false,
        swipe: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.slider-single').on('afterChange', function(event, slick, currentSlide) {
        $('.comparison-table').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.comparison-table .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');

        // $('.slider-nav .slick-track').css({'width': '100%'});
    });

    $(document).on('click', '.comparison-table', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');
        $('.slider-single').slick('slickGoTo', goToSingleSlide);
    });
    $(document).on('click', '.comparison-filter__item', function (e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });
    $(document).on('click', '.comparison-variants__item', function (e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });
});
$(function () {
    $(window).scroll(function () {
        var comparisonTableHeight = $('.comparison-characteristics-components__table').height();
        var comparisonCardsHeight = $('.comparison-characteristics-components__cards').height();
        if (document.documentElement.clientWidth < 992) {
            var headerMainHeight = $('.mobile-header').height();
        } else {
            var headerMainHeight = $('.header-main').height();
        }
        var comparisonObjectsHeight = $('.comparison-objects-wrapper').height();
        var mainTitleHeight = $('.main-title').height();
        var comparisonTableHeight = $('.comparison-characteristics-components__table').height();
        var scrollTopHeight = comparisonCardsHeight + headerMainHeight + comparisonObjectsHeight + mainTitleHeight;
        var scrollStopHeight = scrollTopHeight + mainTitleHeight;


            if (comparisonTableHeight >= 800) {
                if ($(this).scrollTop() > scrollTopHeight) {
                    $('.comparison-characteristics-components__cards').addClass('sticky');
                } else {
                    $('.comparison-characteristics-components__cards').removeClass('sticky');
                }
            }

    });
});
$(document).ready(function () {
    $(document).on('click', '.cart-item-counter__plus', function () {
        let cartCount = $(this).closest('.cart-item-counter').find('.cart-item-counter__input').val();
        $(this).closest('.cart-item-counter').find('.cart-item-counter__input').val(parseInt(cartCount) + 1);
        $(this).closest('.cart-item-counter').find('.cart-item-counter__minus').removeClass('disabled');
    });
    $(document).on('click', '.cart-item-counter__minus', function () {
        let cartCount = $(this).closest('.cart-item-counter').find('.cart-item-counter__input').val();
        if (parseInt(cartCount) >= 2) {
            $(this).closest('.cart-item-counter').find('.cart-item-counter__input').val(parseInt(cartCount) - 1);
        }
        if (parseInt(cartCount) <= 2) {
            $(this).addClass('disabled');
        }
    });
    $(document).on('click', '.option-remove', function () {
        $(this).closest('.cart-product-item').animate({
            opacity: 0
        }, 500, function () {
            $(this).hide();
        });
    });
    $(document).on('click', '.special-offers-variants__list-item', function (e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });
    $(document).on('click', '.wrapper-variants__item', function () {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });

    function accordeonInit(id) {
        $(id).accordion();
    }
    function tabsInit(id) {
        $(id).tabs();
    }
    tabsInit('#tabs');
    accordeonInit("#accordion");
    accordeonInit(".accordeon-init");
    $('.fancybox-init').fancybox();
    $('.popup-form').validate();
    $('.content-show-btn').on('click', function () {
        $(this).prev('.hidden-content').slideDown();
        $(this).hide();
    });

});
$(function () {
    $('input[type="tel"]').inputmask("+7(999)999-99-99");
    $('.custom-scrollbar').mCustomScrollbar({
        axis:"x",
        theme:"light-3",
        advanced:{
            autoExpandHorizontalScroll:true
        }
    });
    $('.vertical-scrollbar').mCustomScrollbar({
        axis:"y",
        theme:"light-3",
        advanced:{
            autoExpandHorizontalScroll:true
        }
    });
});

$( function() {
    $(".static-text select").selectmenu();
    $(document).on('change', '.file', function() {
        if ($(this).val()) {
            /* There are files */
            $(this).next().next('.downloaded-file').css('display', 'inline-flex');
            $(this).next().next().next('.not-downloaded').css('display', 'none');
        } else {
            $(this).next().next('.downloaded-file').css('display', 'none');
            $(this).next().next().next('.not-downloaded').css('display', 'inline-block');
        }
    });
    $(document).on('click', '.icon-remove-file', function () {
        $(this).closest('.downloaded-file').css('display', 'none');
        $(this).closest('.downloaded-file').next().css('display', 'inline-block');
    });
} );


$(window).on('scroll', function () {
    if ($(this).scrollTop() >= 172) {
        $('.header-main__bottom').addClass('sticky-menu');
    } else {
        $('.header-main__bottom').removeClass('sticky-menu');
    }
});
$(window).on('scroll', function () {
    if ($(this).scrollTop() >= 75) {
        $('.mobile-header__top').addClass('sticky-menu');
    } else {
        $('.mobile-header__top').removeClass('sticky-menu');
    }
});
$(document).on('click', '.background-overlay', function () {
    $(this).slideToggle();
    $('.mobile-header-menu').slideUp();
    $('.mobile-header__search').slideUp();
    $('.mobile-header__filter').slideUp();
});

$(document).ready(function () {
    $('.preview-big-pictures__item-picture').fancybox({
        baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-content-wrapper">' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            "</div>" +
            '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
            '</div>' +
            '</div>' +
            "</div>",
        thumbs: {
            autoStart: true, // Display thumbnails on opening
            hideOnClose: true, // Hide thumbnail grid when closing animation starts
            parentEl: ".fancybox-content-wrapper", // Container is injected into this element
            axis: "x" // Vertical (y) or horizontal (x) scrolling
        },
        helpers: {
            title: {
                type: 'inside',
                position: 'bottom'
            }
        },
        caption : function( instance, item ) {
            var caption = $(this).data('caption') || '';
            return ( caption.length ? caption + '<br />' : '' );
        },
        mouseWheel: false,
        afterLoad: function () {
            if ($('.fancybox-slide').length == 1) {
                $('.fancybox-button--arrow_left').hide();
                $('.fancybox-button--arrow_right').hide();
                $('.fancybox-inner').css('height', '100%');
                $('.fancybox-content-wrapper').addClass('single-slide');
            } else {
                $('.fancybox-button--arrow_left').show();
                $('.fancybox-button--arrow_right').show();
                $('.fancybox-content-wrapper').removeClass('single-slide');
            }
        },
        selector : '.preview-big-pictures__item-picture',
        clickContent: false
    });
    $('.tabs-list').mCustomScrollbar();


});

    $(document).on('load resize scroll', function () {
        if ($(window).width() > 767) {
            let blockTop = $(this).scrollTop();
            let headerHeight = $('.header-main').innerHeight();
            let orderBlock = $('.checkout-order__grid').innerHeight();
            let blockHeight = $('.checkout-order-total').innerHeight();
            let scrollStop = headerHeight + blockHeight;
            if ((blockTop > 212) && (blockTop <= 1000)) {
                $('.checkout-order-total').css({'top': blockTop - blockHeight / 2 + 32, 'bottom': 'auto'});
            } else if (blockTop > orderBlock - blockHeight) {
                $('.checkout-order-total').css({'top': 'auto', 'bottom': 0});
            } else {
                $('.checkout-order-total').css({'top': 'auto', 'bottom': 'auto'});
            }
        }
    });
// тултип для ссылки полного наименования
function showTooltip(targetItems, name){
    $(targetItems).each(function(i){
        var badgeDescription = $(this).attr('data-full-name');
        $('body').append("<div class='"+ name +"' id='"+ name + i +"'>"+ badgeDescription +"</div>");

        var tooltip = $('#'+name+i);
        $(this).removeAttr("data-full-name").mouseenter(function(){
            tooltip.css({opacity:0.9, display:'none'}).fadeIn();
        }).mousemove(function(kmouse){
            tooltip.css({left:kmouse.pageX+15, top:kmouse.pageY+15});
        }).mouseleave(function(){
            tooltip.fadeOut();
        });
    });
}
$(document).ready(function(){
    showTooltip('.product-detail-top__left-all', 'tooltip-custom');
});
$(document).ready(function() {
    let allMenuPoints = $('.toggle-menu-list__content-item');
    if ($(window).width() <= 1200) {
        allMenuPoints.each(function() {
            let arrow = $(this).find('.level-switch-over');
            if (arrow) {
                arrow.prev().addClass('link-block');
                arrow.parent().addClass('toggle-list-submenu');
            }
        });
    }
    $(window).on('resize', function () {
        if ($(window).width() <= 1200) {
            allMenuPoints.each(function() {
                let arrow = $(this).find('.level-switch-over');
                if (arrow) {
                    arrow.prev().addClass('link-block');
                    arrow.parent().addClass('toggle-list-submenu');
                }
            });
        }
    });
});

$(document).ready(function () {
   $(document).on('click', '.accordeon-button', function () {
       $(this).next('.accordeon-toggle').slideToggle();
       $(this).toggleClass('accordeon-hidden');
   });
   $('.items-cart-wrapper').mCustomScrollbar({
       theme:"dark"
   });
});
$(document).on('click', '.toggle-list-submenu', function (e) {
    $(this).children('.mobile-deep-menu').slideDown();
});
$(document).on('click', '.level-menu-close', function (e) {
    e.preventDefault();
    $(this).closest('.mobile-deep-menu').slideUp();
    e.stopPropagation();
});
$('.product-colors-list__variant').on('click', function () {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
});
$(document).on('input', '.header-middle__search-input', function () {
    if ($(this).val() !== '') {
        $(this).parent('.header-middle__search > form').addClass('filled');
    }
    else {
        $(this).parent('.header-middle__search > form').removeClass('filled');
    }
});
$(document).on('input', '.range-min', function () {
    if ($(this).val() !== '') {
        $(this).addClass('filled');
    }
    else {
        $(this).removeClass('filled');
    }
});
$(document).on('input', '.range-max', function () {
    if ($(this).val() !== '') {
        $(this).addClass('filled');
    }
    else {
        $(this).removeClass('filled');
    }
});
$(document).on('click', '.header-middle__search-remove', function () {
    $(this).closest('.header-middle__search > form').removeClass('filled');
});

// $(document).on('mouseleave', '.cart-btn', function(e){
//
//     // клик внутри элемента
//     $(this).next('.cart-popup').fadeOut();
// });
$(document).on('mouseleave', '.cart-popup', function(e){

    // клик внутри элемента
    $(this).fadeOut();
});
$(document).on('mouseover', '.cart-btn', function(e){
    // $(this).next('.cart-popup').fadeIn();
    if ( $(this).next('.cart-popup').length ) {
        // клик внутри элемента
        $(this).next('.cart-popup').fadeIn();
        return;
    }
    // клик снаружи элемента
    $('.cart-popup').fadeOut();
});
// $(document).on('mouseleave', '.cart-btn', function(e){
//     if ( !$(this).next('.cart-popup').length ) {
//         // клик внутри элемента
//         $(this).next('.cart-popup').fadeOut();
//         return;
//     }
//         // клик внутри элемента
//
// });


